export const ACTION_TYPES = {
  POST_CREATE_PAYMENT: Symbol("POST_CREATE_PAYMENT"),
  SET_CREATE_PAYMENT_STATE: Symbol("SET_CREATE_PAYMENT_STATE"),
  CLEAR_STATE: Symbol("CLEAR_STATE")
};
